import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LearningResourcesListComponent } from './learning-resources-list/learning-resources-list.component';
import { LearningResourcesCreateComponent } from './learning-resources-create/learning-resources-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: LearningResourcesListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: LearningResourcesCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'learning-resources-create/:id',
        component: LearningResourcesCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LearningResourcesRoutingModule { }
